import { ApolloClient, InMemoryCache } from '@apollo/client';

export const contentfulGQLClient = new ApolloClient({
  uri: `https://graphql.contentful.com/content/v1/spaces/uf75r07g6qrc/environments/master`,
  cache: new InMemoryCache(),
  connectToDevTools: false,
  headers: {
    authorization: `Bearer tfTypSQL17vERRnGGfqpsHnmkGAXwFhmpPqwNN41UME`,
  },
});
